import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setActiveMasterButton } from 'shared/common/slices/stickyPromoSlice';

function isVisibleElement(element: Element) {
  const style = window.getComputedStyle(element);

  return element.getClientRects().length > 0 && style.display !== 'none' && style.visibility !== 'hidden';
}

function getSellerPresentationButton() {
  const buttons = [
    document.querySelector('[data-name=HelpYouSellButtonsDesktop]'),
    document.querySelector('[data-name=HelpYouSellButtonsMobile]'),
  ].filter(Boolean) as Element[];

  return buttons.find(isVisibleElement);
}

/**
 * Хук для управления отображением стики-кнопок.
 * В один момент может быть видна только одна кнопка.
 * */
export const useFillApplicationStickyButtons = ({ landing }: { landing: 'seller' | 'buyer' }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const presentationBtn =
      landing === 'seller'
        ? getSellerPresentationButton()
        : (document.querySelector('[data-name=HelpYouBuy]') as Element);

    if (!presentationBtn) {
      return;
    }

    const bottomButtonObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            dispatch(setActiveMasterButton(false));
          } else {
            dispatch(setActiveMasterButton(entry.boundingClientRect.bottom <= 0));
          }
        });
      },
      {
        threshold: 0,
        rootMargin: '0px',
      },
    );

    bottomButtonObserver.observe(presentationBtn);

    return () => {
      bottomButtonObserver.disconnect();
    };
  }, [dispatch, landing]);
};
